import React from "react";
import ReactDOM from "react-dom/client";
import "driver.js/dist/driver.css";  // load first so our overrides in index.css win
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
